// extracted by mini-css-extract-plugin
module.exports = {"main":"FooterAuth_main__2apm_","footerLogo":"FooterAuth_footerLogo__1xkpj","cp":"FooterAuth_cp__38BDk","content":"FooterAuth_content__1r5g3"};